import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

export interface IIconArrow extends IIcon {
  rotate: boolean;
}

const svg = (rotate: boolean) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    style={{ transform: rotate ? 'rotate(180deg)' : 'rotate(0deg)', width: 'inherit', height: 'inherit' }}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M17.625 9A8.625 8.625 0 1 1 .375 9a8.625 8.625 0 0 1 17.25 0Zm-.75 0a7.875 7.875 0 1 0-15.75 0 7.875 7.875 0 0 0 15.75 0ZM6.265 7.428l2.917 2.917 2.917-2.917a.375.375 0 1 1 .53.53L9.447 11.14a.375.375 0 0 1-.53 0L5.735 7.958a.375.375 0 0 1 .53-.53Z"
      clipRule="evenodd"
    />
  </svg>
);

const IconArrow: React.FC<IIconArrow> = (props: ReactProps) => {
  const { rotate, ...prop } = props;
  return <Icon {...prop} svg={() => svg(rotate)} />;
};

export default IconArrow;
